var MeasurementsPrice = 0;
var HeaderType = 0;
var Position = 1;
var Lining = 0;
var LiningPrice = 0;
var ManufactureMakeUp = 2600;
var ManufactureFabricLining = 0;
var ManufactureCarriage = document.getElementById('fixed_cost').innerHTML;
var metresWidth = 0;
var metres = 0;
var eachCurtain = 0;
var LiningLineItem = "Unlined";
var HeaderTypeLineItem = "Not chosen";
var HeaderTypeLineItemOption = "Not chosen";
var HeaderCutSize = 0;
var FixedCosts = document.getElementById('fixed_cost').innerHTML;
var PositionLineItem = "none";
var HeaderTypeLineItem = "none";
var HeaderTypeLineItemOption = "none";
var headFullness = 0;
var CurtainMetres = 0;
var TotalWidth = 0;
var curtainUnits = document.getElementsByName('measurement');
var eyeletColor = '';
var addOnId;
var totalVAT = 0;

var headerQuantity = 0;
var liningQuantity = 0;
var headerId, metres, customWidth, customDrop, headSize, CutSize, CurtainTotal;
var liningId = null;

var maxSize = 400;
var minSize = 70;

var classnameCurtainSize = document.getElementsByClassName("curtain-size");
var classnameHeaderType = document.getElementsByClassName("header-type");
var classnameHeaderTypeOptions = document.getElementsByClassName("header-type-options");
var classnamePosition = document.getElementsByClassName("position");
var classnameLining = document.getElementsByClassName("lining");
var classnameNeedHelp = document.getElementsByClassName("need-help");
var addOns = document.getElementsByClassName('add-on-option');
var locationSelect = document.getElementById('locationSelect');

for (var i = 0; i < classnameCurtainSize.length; i++) {
    classnameCurtainSize[i].addEventListener('input', CurtainSize, false);
}
for (var i = 0; i < classnameHeaderType.length; i++) {
    classnameHeaderType[i].addEventListener('click', CurtainHeaderType, false);
}
for (var i = 0; i < classnameHeaderTypeOptions.length; i++) {
    classnameHeaderTypeOptions[i].addEventListener('click', HeaderTypeOptions, false);
}
for (var i = 0; i < classnamePosition.length; i++) {
    classnamePosition[i].addEventListener('click', CurtainPosition, false);
}
for (var i = 0; i < classnameLining.length; i++) {
    classnameLining[i].addEventListener('click', CurtainLining, false);
}

for (var i = 0; i < classnameNeedHelp.length; i++) {
    classnameNeedHelp[i].addEventListener('click', NeedHelp, false);
}

// Accordion
document.addEventListener('click', function (event) {
    //Bail if our clicked element doesn't have the class
    if (!event.target.classList.contains('accordion-toggle')) return;
    // Get the target content
    var content = document.querySelector(event.target.dataset.hash);
    var accordionsTitle = content.previousElementSibling;
    if (!content) return;
    // Prevent default link behavior
    // If the content is already expanded, collapse it and quit
    if (content.classList.contains('active')) {
        content.classList.remove('active');
        accordionsTitle.classList.remove('active');
        return;
    }
    // scroll to the top of open accordion
    if (window.innerWidth < 768) {
        if (event.target.dataset.hash == "#content-1") {
            document.getElementById('content-1').scrollIntoView({
                behavior: "smooth"
            });
        } else {
            accordionsTitle.previousElementSibling.previousElementSibling.scrollIntoView({
                behavior: "smooth"
            });
        }
    }
    // Get all open accordion content, loop through it, and close it
    var accordions = document.querySelectorAll('.accordion-content.active');
    var accordionsTitles = document.querySelectorAll('.accordion-toggle');
    for (var i = 0; i < accordions.length; i++) {
        accordions[i].classList.remove('active');
    }
    for (var x = 0; x < accordionsTitles.length; x++) {
        accordionsTitles[x].classList.remove('active');
    }
    // Toggle our content
    content.classList.toggle('active');

    if (content.classList.contains('active')) {
        accordionsTitle.classList.add('active');
    } else {
        accordionsTitle.classList.remove('active');
    }
})

for(const curtainUnit of curtainUnits) {
    curtainUnit.addEventListener('change', function(){
        if (curtainUnit.value == 'inch'){
            minSize = 28;
            for (const label of document.getElementsByClassName('measurement_unit')) {
                label.innerText = 'inch';
            }
        } else {
            minSize = 70;
            for (const label of document.getElementsByClassName('measurement_unit')) {
                label.innerText = 'cm';
            }
        }
    });
}


function NeedHelp() {
    //window.location.href = NeedHelpUrl;
    window.open(
        NeedHelpUrl,
        '_blank' // <- This is what makes it open in a new window.
    );
}

var changeCurtainPattern = function (param) {
    var patternOptions = document.querySelectorAll('.curtain-pattern');
    for (patternOption of patternOptions) {
        patternOption.classList.remove('checked')
        patternOption.classList.remove('default-selected')
    }
    if (param) {
        param.classList.add('checked')
        //var variantSample = param.dataset.variant_sample;
        productTitle = param.dataset.pattern_name;
        var variantPrice = param.dataset.variant_price;
        var detailsColour = param.dataset.colour;
        var detailsWidth = param.dataset.width;
        var detailsRepeatCms = param.dataset.repeat_cms;
        var detailsMaterial = param.dataset.material;
        var detailsTitle = param.dataset.pattern_title;
        MetafiledCostPerMetre = param.dataset.metafieldcost;
        detailsVendor = param.dataset.vendor;
        detailsManufacturer = param.dataset.manufacturer;
        SampleImage = param.dataset.pattern_image;
        fabricWidth = param.dataset.fabric_width;
        Repeat = param.dataset.repeat;
        detailsSku = param.dataset.sku;
        console.log('vendor', detailsManufacturer)
        document.getElementById('curtain-product-price').innerHTML = variantPrice;
        document.getElementById('details-vendor').innerHTML = detailsVendor;
        document.getElementById('details-sku').innerHTML = detailsSku;
        document.getElementById('details-colour').innerHTML = detailsColour;
        document.getElementById('details-width').innerHTML = detailsWidth;
        document.getElementById('details-repeat_cms').innerHTML = detailsRepeatCms;
        document.getElementById('details-material').innerHTML = detailsMaterial;
        document.getElementById('details-title').innerHTML = detailsTitle;
        document.getElementById('add-to-cart-sample').dataset.sample_title = detailsTitle;


        /*if (variantSample != "No Sample") {
            document.getElementById('add-to-cart-sample').dataset.sample = variantSample;
            document.getElementById('sample-variant-price').innerHTML = variantSamplePrice;
            document.getElementById('add-to-cart-sample').removeAttribute("disabled", "");
        } else {
            if(document.querySelectorAll('#add-to-cart-sample').length > 0 ){
                document.getElementById('add-to-cart-sample').setAttribute("disabled", "");
            }
        }*/

    }
    const curtainPatternUrl = param.getAttribute("src").replace('50x', '800x');
    const curtainPattern = "url(" + param.getAttribute("src") + ")";
    document.getElementById('curtain-pattern').style.background = curtainPattern;
    DefaultProductId = param.dataset.pattern_id;
    costPerMetre = param.dataset.pattern_cost;
    ColourLineItem = param.dataset.pattern_name;
    var CurtainsHeaderImages = document.querySelectorAll('.position-curtain-container div');
    for (CurtainsHeaderImage of CurtainsHeaderImages) {
        CurtainsHeaderImage.style.background = curtainPattern;
    }
    document.querySelectorAll('.curtain-gallery-image')[0].setAttribute('srcset', curtainPatternUrl);
    UpdateButtonPrice();
}

var loadCurtainPatterns = function (param) {
    const viewNumber = param.nextElementSibling.dataset.view_patterns;
    const viewSelector = '[data-view_patterns="' + viewNumber + '"]';
    const displayPatterns = document.querySelectorAll(viewSelector);
    for (displayPattern of displayPatterns) {
        displayPattern.style.display = "inline-block";
    }
    param.style.display = "none";
}

// clear accordion inputs on browser's 'go back'
window.addEventListener("pageshow", () => {
    document.getElementById('curtainWidth').value = " ";
    document.getElementById('curtainDrop').value = " ";
    document.getElementById('addToCartPopUp').setAttribute('disabled', '');
    document.getElementById('addToCartPopUp').innerHTML = addToCartText;
    var clearAllInputs = document.querySelectorAll('.made-to-measure-accordion input');
    var clearAllCheckedClasses = document.querySelectorAll('.checked');
    for (clearAllInput of clearAllInputs) {
        if(!clearAllInput.classList.contains('measurement-radio')) {
            clearAllInput.checked = false;
        }        
    }
    for (clearAllCheckedClass of clearAllCheckedClasses) {
        clearAllCheckedClass.classList.remove('checked');
    }
});

function CurtainSize() {
    //console.log(customWidth, customDrop)
    if (document.getElementById('inch').checked) {
        customWidth = document.getElementById('curtainWidth').value * 2.54;
        customDrop = document.getElementById('curtainDrop').value * 2.54;
        customWidth = customWidth.toFixed(2);
        customDrop = customDrop.toFixed(2);
    } else {
        customWidth = document.getElementById('curtainWidth').value;
        customDrop = document.getElementById('curtainDrop').value;
    }
    //console.log(customWidth, customDrop)
    metresWidth = parseFloat(customWidth) / 100;
    metres = parseFloat(customDrop) * parseFloat(customWidth) / 10000;
    MeasurementsPrice = parseFloat(metres) * parseFloat(costPerMetre) / 100;
    UpdateButtonPrice();
    if (customWidth < minSize && customWidth != 0) {
        document.querySelector('.error_width.min_width').style.display = "block";
        document.querySelector('.error_width.max_width').style.display = "none";
        document.querySelector('.accordion-curtain-size').classList.add('wrapper_error_width');
    } else if (customWidth > maxSize && customWidth != 0) {
        document.querySelector('.error_width.min_width').style.display = "none";
        document.querySelector('.error_width.max_width').style.display = "block";
        document.querySelector('.accordion-curtain-size').classList.add('wrapper_error_width');
    } else {
        document.querySelector('.error_width.min_width').style.display = "none";
        document.querySelector('.error_width.max_width').style.display = "none";
        document.querySelector('.accordion-curtain-size').classList.remove('wrapper_error_width');
    }
    if (customDrop < minSize && customDrop != 0) {
        document.querySelector('.error_drop.min_drop').style.display = "block";
        document.querySelector('.error_drop.max_drop').style.display = "none";
        document.querySelector('.accordion-curtain-size').classList.add('wrapper_error_drop');
    } else if (customDrop > maxSize && customDrop != 0) {
        document.querySelector('.error_drop.min_drop').style.display = "none";
        document.querySelector('.error_drop.max_drop').style.display = "block";
        document.querySelector('.accordion-curtain-size').classList.add('wrapper_error_drop');
    } else {
        document.querySelector('.error_drop.min_drop').style.display = "none";
        document.querySelector('.error_drop.max_drop').style.display = "none";
        document.querySelector('.accordion-curtain-size').classList.remove('wrapper_error_drop');
    }

    if (document.getElementById('curtainWidth').value >= minSize && document.getElementById('curtainDrop').value >= minSize && document.getElementById('curtainWidth').value <= maxSize && document.getElementById('curtainDrop').value <= maxSize) {
        document.querySelector('[data-hash="#content-1"] .info-selected').style.display = "block";
    } else {
        document.querySelector('[data-hash="#content-1"] .info-selected').style.display = "none";
    }

    CurtainPosition();
    CurtainLining()
    UpdateButtonPrice();

}

function CurtainHeaderType() {
    const headerTypes = document.querySelectorAll(".header-type");
    for (headerTypeOption of headerTypes) {
        if (headerTypeOption.checked) {
            HeaderType = headerTypeOption.dataset.header_price;
            HeaderCutSize = headerTypeOption.dataset.header_cut_size;
            headFullness = headerTypeOption.dataset.header_fullness;
            headerTypeOption.parentNode.classList.add('checked')
            HeaderTypeLineItem = headerTypeOption.parentNode.textContent;
            HeaderTypeLineItemOption = "none";
            var HeaderTypeOptionsSelector = '[data-option_opened="' + headerTypeOption.parentNode.textContent + '"]';
            var ViewHeaderTypeOptions = document.querySelectorAll(HeaderTypeOptionsSelector);
            var HideHeaderTypeOptions = document.querySelectorAll('.header-type-options-container');
            for (HideHeaderTypeOption of HideHeaderTypeOptions) {
                HideHeaderTypeOption.style.display = "block"; //used to be 'none'
            }
            for (ViewHeaderTypeOption of ViewHeaderTypeOptions) {
                ViewHeaderTypeOption.style.display = "block";
                //Currently it it set to automatically select the first option but remove the line below to be able to select many options
                ViewHeaderTypeOption.querySelectorAll('input')[0].click();
            }
        } else {
            headerTypeOption.parentNode.classList.remove('checked')
        }
    }
    UpdateButtonPrice();
}

function HeaderTypeOptions() {
    var HeaderTypeOptions = document.querySelectorAll('.header-type-options');
    for (HeaderTypeOption of HeaderTypeOptions) {
        if (HeaderTypeOption.checked) {
            HeaderTypeLineItemOption = HeaderTypeOption.parentNode.querySelector('p').textContent;
            HeaderTypeOption.parentNode.classList.add('checked')
            headerId = HeaderTypeOption.dataset.header_id;
            if (HeaderTypeOption.dataset.color == 'true') {
                var colorSet = document.getElementById('color-' + HeaderTypeOption.dataset.header_id);
                colorSet.classList.remove('hidden');
            } else {
                for (const swatchContainer of document.getElementsByClassName('swatch-accordion')) {
                    swatchContainer.classList.add('hidden');
                }
                for (const swatch of document.getElementsByClassName('color-header-option')) {
                    swatch.checked = false;
                    properties = '';
                }
            }
        } else {
            HeaderTypeOption.parentNode.classList.remove('checked');
        }
    }

    const headerTypes = document.querySelectorAll(".header-type");
    for (headerTypeOption of headerTypes) {
        if (headerTypeOption.parentNode.innerText == HeaderTypeLineItemOption) {
            headerTypeOption.click();
        }
    }

    if (HeaderTypeLineItemOption != 0) {
        document.querySelector('[data-hash="#content-2"] .info-selected').style.display = "block";
    }
    //GalleryImageChange();
    UpdateButtonPrice();
}

var ColorTypeOptions = document.getElementsByClassName('eyelet-option');
for (const ColorTypeOption of ColorTypeOptions) {
    ColorTypeOption.addEventListener('change', function(){
        console.log(ColorTypeOption);
        if (ColorTypeOption.checked) {
            ColorTypeOption.nextElementSibling.classList.add('active');
            eyeletColor = { 'Eyelet Colour': ColorTypeOption.value };
        } else {
            ColorTypeOption.nextElementSibling.classList.remove('active');
            eyeletColor = '';
        }
    })
}

function CurtainPosition() {
    const positionTypes = document.querySelectorAll(".position");
    for (positionType of positionTypes) {
        if (positionType.checked && positionType.dataset.position == "double") {
            Position = 2;
            PositionLineItem = positionType.parentNode.textContent;
            positionType.parentNode.classList.add('checked')
            customWidth = document.getElementById('curtainWidth').value;
            headSize = customWidth / Position + 10;
            fabricWidthEachCurtain = fabricWidth - 8;
            eachCurtain = ((headSize * headFullness) / fabricWidthEachCurtain).toFixed(2);
            if (eachCurtain <= 1.1) {
                headerQuantity = 1;
            } else if (eachCurtain > 1.1 && eachCurtain <= 1.65) {
                headerQuantity = 1.5;
            } else if (eachCurtain > 1.65 && eachCurtain <= 2.2) {
                headerQuantity = 2;
            } else if (eachCurtain > 2.2 && eachCurtain <= 2.75) {
                headerQuantity = 2.5;
            } else if (eachCurtain > 2.75 && eachCurtain <= 3.3) {
                headerQuantity = 3;
            } else if (eachCurtain > 3.3 && eachCurtain <= 3.85) {
                headerQuantity = 3.5;
            } else if (eachCurtain > 3.85 && eachCurtain <= 4.4) {
                headerQuantity = 4;
            } else if (eachCurtain > 4.4 && eachCurtain <= 4.95) {
                headerQuantity = 4.5;
            } else {
                headerQuantity = "Not available"
            }
        } else if (positionType.checked && positionType.dataset.position == "single") {
            Position = 1;
            PositionLineItem = positionType.parentNode.textContent;
            positionType.parentNode.classList.add('checked')
            customWidth = document.getElementById('curtainWidth').value;
            headSize = customWidth / Position + 10;
            fabricWidthEachCurtain = fabricWidth - 8;
            eachCurtain = ((headSize * headFullness) / fabricWidthEachCurtain).toFixed(2);
            if (eachCurtain <= 1.1) {
                headerQuantity = 1;
            } else if (eachCurtain > 1.1 && eachCurtain <= 2.2) {
                headerQuantity = 2;
            } else if (eachCurtain > 2.2 && eachCurtain <= 3.3) {
                headerQuantity = 3;
            } else if (eachCurtain > 3.3 && eachCurtain <= 4.4) {
                headerQuantity = 4;
            } else if (eachCurtain > 4.4 && eachCurtain <= 5.5) {
                headerQuantity = 5;
            } else if (eachCurtain > 5.5 && eachCurtain <= 6.6) {
                headerQuantity = 6;
            } else if (eachCurtain > 6.6 && eachCurtain <= 7.7) {
                headerQuantity = 7;
            } else if (eachCurtain > 7.7 && eachCurtain <= 8.8) {
                headerQuantity = 8;
            } else {
                headerQuantity = "Not available"
            }
        } else {
            positionType.parentNode.classList.remove('checked')
        }
    }
    
    if (document.querySelectorAll('.position-curtain-container.checked').length > 0) {
        document.querySelector('[data-hash="#content-3"] .info-selected').style.display = "block";
    }
    //GalleryImageChange();
    UpdateButtonPrice();
}

function CurtainLining() {

    const liningTypes = document.querySelectorAll(".lining");
    for (liningType of liningTypes) {
        if (liningType.checked) {
            LiningPrice = liningType.dataset.lining_price;
            LiningLineItem = liningType.parentNode.textContent;
            liningType.parentNode.classList.add('checked');
            liningId = liningType.dataset.lining_id;
        } else {
            liningType.parentNode.classList.remove('checked');
        }
    }

    liningQuantity = Math.ceil(metres);
    //console.log(LiningPrice, LiningLineItem, liningId, liningQuantity)


    if (LiningLineItem != 0 && LiningLineItem != "Unlined") {
        document.querySelector('[data-hash="#content-4"] .info-selected').style.display = "block";
    } else {
        document.querySelector('[data-hash="#content-4"] .info-selected').style.display = "none";
    }
    UpdateButtonPrice()
}

function GalleryImageChange() {
    if (HeaderTypeLineItemOption != "none") {
        var defaultMadeToMeasureImageSelector = imageRoot + "/assets/" + HeaderTypeLineItem + "-" + HeaderTypeLineItemOption + "-" + PositionLineItem + "_800x800_crop_center.png";
        var defaultMadeToMeasureImage = defaultMadeToMeasureImageSelector.replace(/ /g, '');
        document.getElementById('curtain-image').setAttribute('src', defaultMadeToMeasureImage);
    } else {
        var defaultMadeToMeasureImageSelector = imageRoot + "/assets/Pencil-Pencil-" + PositionLineItem + "_800x800_crop_center.png";
        var defaultMadeToMeasureImage = defaultMadeToMeasureImageSelector.replace(/ /g, '');
        document.getElementById('curtain-image').setAttribute('src', defaultMadeToMeasureImage);
    }
}

function UpdateButtonPrice() {
    //var ManufactureTotal = ManufactureMakeUp + ManufactureFabricLining + ManufactureCarriage;

    // total width that is rounded according to rounding formula / position either 1 or 2 
    TotalWidth = headerQuantity * Position;
    //make up = header price * each curtain * position either 1 or 2
    var MakeUp = (HeaderType / 100) * TotalWidth;
    // cut size = ((drop * header cut size * header repeat) / 100) * header repeat
    var customDrop = document.getElementById('curtainDrop').value;
    var CutSizeRepeat = (parseFloat(customDrop) + parseFloat(HeaderCutSize)) / Repeat;
    CutSize = Math.ceil(CutSizeRepeat) * Repeat;
    // (cut size + total with of both or one crtain depending if single or pair /100 and rounded to the nearest next whole number
    CurtainMetres = Math.ceil((CutSize * TotalWidth) / 100);
    // (cost per metre + lining value) * curtain metres
    var FabricAndLining = ((parseFloat(costPerMetre) / 100) + (LiningPrice / 100)) * CurtainMetres;
    CurtainTotal = MakeUp + (ManufactureCarriage / 100) + FabricAndLining;

    //var CurtainTotal = (((((Math.ceil(metres) * parseFloat(costPerMetre)) / 100)) + ((headerQuantity * HeaderType) / 100) + ((liningQuantity * LiningPrice) / 100))) + (FixedCosts / 100);

    if (!isNaN(parseFloat(CurtainTotal))) {
        if (document.querySelectorAll('.position-curtain-container.checked').length > 1 && (document.getElementById('curtainWidth').value >= minSize && document.getElementById('curtainWidth').value <= maxSize) && (document.getElementById('curtainDrop').value >= minSize && document.getElementById('curtainDrop').value <= maxSize) && (headerQuantity != "Not available") && (liningId != null)) {
            document.getElementById('addToCartPopUp').removeAttribute("disabled")
            totalVAT = CurtainTotal;
            // document.getElementById('addToCartPopUp').innerHTML = addToCartText + " for £" + totalVAT.toFixed(2);
            document.getElementById('total').innerHTML = "£" + totalVAT.toFixed(2);
        } else {
            document.getElementById('addToCartPopUp').setAttribute("disabled", "disabled")
        }
    }
}

function UpdateCartQuantity() {
    var addItem = document.querySelectorAll('.js-cart-count')
    var addItemsCount = document.querySelectorAll('.product-remove');
    for (var i = 0; i < addItem.length; i++) {
        addItem[i].innerHTML = parseInt(addItemsCount.length) + 1;
    }
}
function UpdateCartQuantitySample() {

    var addItem = document.querySelectorAll('.js-cart-count')
    var addItemsCount = document.querySelectorAll('.product-remove');
    var alreadyHasSample = false;

    fetch("/cart.json")
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            var dataItems = data.items;
            //console.log(dataItems)
            for (let i = 0; i < dataItems.length; i++) {
                console.log(dataItems[i].properties['Sample of'], document.getElementById('add-to-cart-sample').dataset.sample_title)
                if (dataItems[i].properties['Sample of'] == document.getElementById('add-to-cart-sample').dataset.sample_title) {
                    alreadyHasSample = true;
                }
            }

            //console.log(alreadyHasSample)

            if (alreadyHasSample == true) {
                for (var i = 0; i < addItem.length; i++) {
                    addItem[i].innerHTML = parseInt(addItemsCount.length);
                    //console.log('sample exists')
                }
            } else {
                for (var i = 0; i < addItem.length; i++) {
                    addItem[i].innerHTML = parseInt(addItemsCount.length) + 1;
                    //console.log('sample doesnt exists')
                }
            }
        })
        .catch(function (err) {
            //console.log(err);
        });
}


if (document.querySelectorAll('#add-to-cart-sample').length > 0) {
    document.getElementById('add-to-cart-sample').addEventListener('click', (event) => {
        UpdateCartQuantitySample()
        var SampleId = document.getElementById('add-to-cart-sample').dataset.sample;
        var addData = {
            id: SampleId,
            properties: { 'Sample of': productTitle, 'SKU': detailsSku, 'Manufacturer': detailsManufacturer, 'Sample image': SampleImage },
            quantity: 1
        };
        fetch('/cart/add.js', {
            body: JSON.stringify(addData),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
            },
            method: 'POST'
        }).then(function (response) {
            return response.json();
        }).then(function (json) {
            document.querySelector('.my-cart-link-container .js-slideout-open').click();
        }).catch(function (err) {
        });
    });
}

for(const line of document.getElementsByClassName('lining-option-checks')) {
    line.addEventListener('click', function(){
        console.log(line);
        if(line.value == 'Unlined') {
            document.querySelector('.lining-option-color-container').classList.add('disabled');
            document.getElementById('.liningSelect').value = '';
        } else {
            document.querySelector('.lining-option-color-container').classList.remove('disabled');
        }
    })
}

document.getElementById('addToCartPopUp').addEventListener('click', (event) => {
    document.querySelector('body').classList.add('slideout-right--open');
    document.querySelector('.pop-up-wrapper').style.display = "block";
    document.getElementById('pop-up-container').style.display = "flex";
});

document.getElementById('AddtoCartCustomCurtain').addEventListener('click', (event) => {
    document.getElementById('pop-up-container').style.display = "none";
});

document.getElementById('pop-up-go-back').addEventListener('click', (event) => {
    document.querySelector('body').classList.remove('slideout-right--open');
    document.getElementById('pop-up-container').style.display = "none";
    //newParent.style.display = "block";
});

//Generate random key so if the same product is added, it displays as separate
let random_key;
function generateRandomKey() {
    function makeid(length) {
        var result = '';
        var characters = '0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }
    random_key = makeid(6);
    //console.log(random_key)
}
generateRandomKey();

for(const addOn of addOns) {
    addOn.addEventListener('click', function(){
        addOn.classList.add('checked');
        var checkbox = addOn.querySelector('.add-on-option-checkbox-input');
        if(checkbox.checked) {
            addOnId = parseInt(checkbox.dataset.id);
            var price = parseFloat(checkbox.dataset.price);
            if (!isNaN(parseFloat(totalVAT))) {
                var sum = totalVAT + price;
                document.getElementById('total').innerHTML = "£" + sum.toFixed(2);
            }
        } else {
            addOnId = '';
            addOn.classList.remove('checked');
            document.getElementById('total').innerHTML = "£" + totalVAT.toFixed(2);
        }
    });
}

document.getElementById('AddtoCartCustomCurtain').addEventListener('click', (event) => {
    //UpdateCartQuantity()
    //newParent.style.display = "block";
    var DefaultProductQuantity = CurtainMetres;
    var properties = { 'Curtain Location': locationSelect.value };
    var liningProperties = { 'Lining Colour': document.getElementById('liningSelect').value };
    var addData = {
        items: [
            {
                id: parseInt(DefaultProductId),
                quantity: CurtainMetres,
                properties: properties
            },
            {
                id: parseInt(headerId),
                quantity: TotalWidth,
                properties: eyeletColor
            },
            {
                id: parseInt(liningId),
                quantity: CurtainMetres,
                properties: liningProperties
            },
            {
                id: 43721952919692,
                quantity: 1
            }
        ]
    };

    console.log(addOnId);

    if(addOnId) {
        var addOn = { id: addOnId, quantity: 1 };
        addData.items.push(addOn);
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(addData)
    })
    .then(response => {
        location.href = '/checkout';
    })
    .catch((error) => {
        console.error('Error:', error);
    });
});  